const THREE = require('three')
import {loadingManager, load, registerSize} from '../loader'
import {TweenMax, Cubic} from 'gsap'
import store from 'src/store'


const frames = 30
const fps = 30


// WRAPPER
export let mesh = new THREE.Object3D()
export default mesh
mesh.name = 'eyelid'


// GEOMETRY
let size = 1024
let geometry = new THREE.PlaneBufferGeometry(size, size / 2)





// MATERIAL
let material = new THREE.MeshBasicMaterial({
  transparent: true,
  side: THREE.DoubleSide
})
material.depthTest = false
material.depthWrite = false
let url = require('assets/race/eyelid.png')
registerSize(url, 19773)
load(url, new THREE.TextureLoader(loadingManager), (results)=> {
  material.map = results[0]
  material.needsUpdate = true
})


// MESH
export let topLid = new THREE.Mesh(geometry, material)
export let bottomLid = new THREE.Mesh(geometry, material)
topLid.name = 'topLid'
bottomLid.name = 'bottomLid'
mesh.add(topLid)
mesh.add(bottomLid)


// RESIZE
const onResize = function () {
  let scale = {
    x: window.innerWidth / size,
    y: window.innerHeight / (size / 2)
  }
  topLid.scale.set(scale.x, scale.y, 1)
  bottomLid.scale.set(scale.x, scale.y * -1, 1)
}
onResize()
store.watch(function (state) {
  return store.state.browser.windowWidth
}, onResize)
store.watch(function (state) {
  return store.state.browser.windowHeight
}, onResize)





// PLAY
export const open = function (time = 1) {

  return new Promise((resolve)=> {
    TweenMax.to(topLid.position, time, {
      y: window.innerHeight * 0.8,
      ease: Cubic.easeOut
    })

    TweenMax.to(bottomLid.position, time, {
      y: -window.innerHeight * 0.8,
      ease: Cubic.easeOut,
      onComplete: ()=> {
        mesh.visible = false
        resolve()
      }
    })
  })

}

export const close = function (time = 1) {


  return new Promise((resolve)=> {

    mesh.visible = true

    TweenMax.to(topLid.position, time, {
      y: 0,
      ease: Cubic.easeOut
    })

    TweenMax.to(bottomLid.position, time, {
      y: 0,
      ease: Cubic.easeOut,
      onComplete: resolve
    })

  })

}

// SHOW
// export const show = function () {
//   TweenMax.to(material, 1, {
//     opacity: 1,
//     ease: Cubic.easeIn
//   })
// }

// // HIDE
// export const hide = function () {
//   // mesh.position.z = 3
//   TweenMax.to(material, 1, {
//     opacity: 0,
//     ease: Cubic.easeIn
//   })
// }






// WEBPACK FOOTER //
// ./src/components/game/ui/eyelid.js